module.exports = __webpack_public_path__ + "static/media/landing_setup.67325b3e.svg";